import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()((theme) => ({
   groupBox: {
      marginLeft: '5px',
      marginBottom: '5px',
      paddingBottom: '10px',
      paddingTop: '10px',
      paddingRight: '10px',
      paddingLeft: '10px'
   },
   groupBoxBorder: {border: '1px solid lightgray', borderRadius: 5},
   fullWidth: {
      width: '100%'
   },
   groupBoxText: {
      verticalAlign: 'middle',
      marginTop: '-22px',
      backgroundColor: 'inherit',
      width: 'fit-content'
   }
}));

export interface GroupBoxProps {
   children: React.ReactNode;
   label?: string;
   fullWidth?: boolean;
   style?: React.CSSProperties;
   className?: string;
   classNameLabel?: string;
   hideBorder?: boolean;
}
/**
 * Generar una caja con bordes para agrupar los componentes internos.
 */
function GroupBox({
   children,
   label,
   fullWidth,
   style,
   className,
   classNameLabel,
   hideBorder
}: GroupBoxProps) {
   const {classes, cx} = useStyles();
   return (
      <div
         style={style}
         className={cx(classes.groupBox, className, {
            [classes.fullWidth]: fullWidth,
            [classes.groupBoxBorder]: !hideBorder
         })}
      >
         <Typography className={cx(classes.groupBoxText, classNameLabel)}>{label}</Typography>
         {children}
      </div>
   );
}
GroupBox.propTypes = {
   /**
    * Texto ha mostrar sobre la caja de grupo.
    */
   label: PropTypes.string
};
export default GroupBox;
